import React from 'react';

export default function BillingSuccess() {
  return (
    <div style={{ padding: '2rem', maxWidth: '400px', margin: '0 auto', textAlign: 'center' }}>
      <h2>Thank you for subscribing to 2ndCounsel!</h2>
      <p>Your payment was received. Our team will reach out shortly to complete your onboarding and get your firm set up. If you have any questions in the meantime, email us at support@2ndcounsel.com</p>
    </div>
  );
}
